import { Citation } from "./Citation";
import DownloadForOfflineIcon from "@mui/icons-material/DownloadForOffline";
import { Box, Button, Divider, IconButton, Typography } from "@mui/material";

import { METADATA } from "../assets";
import { HucFeatureProperties } from "../hooks/useFetchHucs";
import { useRasterMetadata } from "../hooks/useRasterMetadata";
import { MetadataItem } from "./MetadataItem";
import { getRasterDownloadUrl, RasterResolution } from "../utilities/getRasterDownloadUrl"
import React from "react";
import { useToggleArray } from "../hooks/useToggleArray";
import { DatasetDownload } from "../components/DatasetDownload"

export interface Props extends HucFeatureProperties { }

function download(href: string, samePage: boolean = true) {
    if (samePage) {
        window.location.href = href
        return
    }
    window.open(href)
}

export const HucDrawerChildren = (props: Props) => {
    // hooks
    const { itemState, toggleItem } = useToggleArray(Array(3).fill(false))
    const { getSingleRasterMetadata } = useRasterMetadata(METADATA, { cacheTime: Infinity, staleTime: Infinity })
    const rasterResolutions = [10, 30, 90]

    // props
    const { name, hucId } = props;

    const metadata = getSingleRasterMetadata(hucId)


    return (
        <Box sx={{ display: "flex", flexDirection: "column", height: "inherit" }}>
            <Box sx={{ flexGrow: 1, m: 2 }}>
                <Typography variant='h6'>
                    {name} (HUC: {hucId})
                </Typography>

                <Typography variant='subtitle1'>
                    Downloads
                </Typography>
                {
                    rasterResolutions.map((item, idx) => {
                        return <React.Fragment key={idx}>
                            <Typography variant="body2" color="text.secondary">
                                {item} meter raster<Button color="primary" sx={{ fontSize: "fontSize", textTransform: "none" }} onClick={() => toggleItem(idx)}>Metadata</Button>
                                <IconButton color="primary" onClick={() => download(getRasterDownloadUrl(hucId, item as RasterResolution), true)}>
                                    <DownloadForOfflineIcon />
                                </IconButton>
                            </Typography>
                            {/* MetadataItem should be sibling of Typography element b.c. cannot have div child of p*/}
                            {/* 
                            // @ts-ignore */}
                            {metadata && <MetadataItem state={itemState(idx)} hucId={hucId} min={metadata[`min_${item}_m`]} max={metadata[`max_${item}_m`]} mean={metadata[`mean_${item}_m`]} std={metadata[`std_${item}_m`]} />}
                        </React.Fragment>
                    })
                }
            </Box>
            <Box sx={{ m: 2 }}>
                <DatasetDownload />
            </Box>

            <Box sx={{ flexGrow: 1 }}>
                <Divider sx={{ mb: 2, ml: 0, mr: 0 }} />
                {/* Manuscript citation */}
                <Citation />
            </Box>
        </Box >
    )
}

export default HucDrawerChildren;
